import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import BusinessUnitTag from 'ui-business-units-lib/components/BusinessUnitTag';
import WithBusinessUnitsDataFetching from 'ui-business-units-lib/utils/WithBusinessUnitsDataFetching';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AccountBrandTag = WithBusinessUnitsDataFetching(BusinessUnitTag);
const DocumentBrandProperty = ({
  brandId
}) => {
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "document-brand-property",
    marginBlock: "200",
    children: brandId !== undefined && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "100",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-50",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "hubspot-prosemirror.documents.brand"
          })
        }), /*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "hubspot-prosemirror.documents.brandTooltip"
          }),
          children: /*#__PURE__*/_jsx(InfoIcon, {
            size: "200",
            color: "icon-core-subtle"
          })
        })]
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(AccountBrandTag, {
          buId: brandId,
          size: "sm"
        })
      })]
    })
  });
};
export default DocumentBrandProperty;